// Tipos de error nuevos de la pantalla de finanzas personales no disponibles
export enum PersonalFinancesUnavailableErrorType {
  // Los datos del documento no son válidos para Cl@ve PIN
  CLAVE_PIN = 'CLAVE_PIN',
  // La consulta a la AEAT no está disponible: se sigue sin finanzas personales
  AEAT_UNAVAILABLE = 'AEAT_UNAVAILABLE',
}
